<template>
	<div>
		<component :is="compName"></component>
	</div>
</template>
<script>
	import Vue from 'vue'
	import axios from '@/axios'
	import {
		mapState
	} from 'vuex'

	export default {
		computed: {
			...mapState({
				post: state => state.user.post,
        appCode:state => state.app.appCode,
			}),
		},
		data() {
			return {
				compName: ''
			}
		},
		mounted() {
		  this.getCabin()
		},
		methods: {
			getCabin() {
				// this.compName = '/system/cabin/main1' 
        this.compName = '/system/cabin/'+this.appCode
				this.registerComponent(this.compName)
			},
			registerComponent(templateName) {
				Vue.component(templateName, require(`@/view${templateName}`).default);
			},


		},

	}
</script>
<style>
	.homeMain {}
</style>



// WEBPACK FOOTER //
// src/view/system/main.vue